import React from 'react';
import Select from 'react-select';
import {
  ReactSelectHelper,
  ReactSelectOnChangeCallback
} from '../../../../../../lib/components/select/base/react-select-types';
import {MQBehavior} from '../../models';

type BehaviorSelectProps = {
  value: MQBehavior;
  onChange: (leftSide: MQBehavior) => void;
};

type OptionType = { value: MQBehavior, label: string };

const options: readonly OptionType[] = [
  {value: 'dragdrop', label: 'Drag and Drop'},
  {value: 'dropdown', label: 'Select'}
];

export class MQBehaviorSelector extends React.Component<BehaviorSelectProps> {
  constructor(props: Readonly<BehaviorSelectProps>) {
    super(props);
    this.handleChange = ReactSelectHelper.mappingSingle(
      'MatchingQuestionLeftType',
      (option: OptionType) => option.value,
      props.onChange);
  }

  handleChange: ReactSelectOnChangeCallback<OptionType>;

  render() {
    const value = options.find(x => x.value === this.props.value)!;

    return (
      <Select<OptionType> options={options}
                          value={value}
                          onChange={this.handleChange}
                          isClearable={false}>
      </Select>);
  }

}
